exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RoomsBeds-roomsBedGap-1agNO {\n    gap: 11px;\n}\n\n.RoomsBeds-bedIcon-O3NWV {\n    width: 100%;\n    max-width: 22px;\n    min-width: 22px;\n}\n\n.RoomsBeds-bedsWidth-3HQT- {\n    width: 70%;\n}\n\n@media screen and (max-width: 767px) {\n    .RoomsBeds-roomsBedGapSection-3ZhwX {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n        gap: 10px;\n    }\n\n    .RoomsBeds-bedsWidth-3HQT- {\n        width: 100%;\n    }\n}", ""]);

// exports
exports.locals = {
	"roomsBedGap": "RoomsBeds-roomsBedGap-1agNO",
	"bedIcon": "RoomsBeds-bedIcon-O3NWV",
	"bedsWidth": "RoomsBeds-bedsWidth-3HQT-",
	"roomsBedGapSection": "RoomsBeds-roomsBedGapSection-3ZhwX"
};